import React, { useState } from 'react';
import 'aos/dist/aos.css'; 
import LA from '../assests/imgs/Logos/Left-Arrow.svg'

export default function HomeProjects() {
  const projects = [
    {
      name: "Interior and Renovations",
      imgSrc: "../assests/imgs/alona-gross-y0Zlus5aCYI-unsplash.jpeg",
    },
    {
      name: "Civils and Roadworks",
      imgSrc: "../assests/imgs/Home Page Click Through/roadworks.jpg",
    },
    {
      name: "Water and Sanitation",
      imgSrc: "../assests/imgs/Home Page Click Through/water-and-sanitation.jpg",
    },
    {
      name: "Beyond South Africa",
      imgSrc: "../assests/imgs/Home Page Click Through/beyond-africa.jpg",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + projects.length) % projects.length);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length);
  };

  return (
    <div id="home-projects" data-aos='fade-up'>
      <div className="abs-bg-shadow m-0"></div>
      <div
        className="slider-wrapper"
        style={{
          transform: `translateX(-${currentIndex * 100}%)`,
        }}
      >
        {projects.map((project, index) => (
          <img
            key={index}
            src={project.imgSrc}
            alt={project.name}
          />
        ))}
      </div>
      <h3  >Our projects.</h3>
      <div className="d-flex justify-content-between">
        <button type="button" className="btn" onClick={handlePrev}>
        <svg id="Component_3_1" data-name="Component 3 – 1" xmlns="http://www.w3.org/2000/svg" width="auto" height="65" viewBox="0 0 87 86">
          <g id="Ellipse_2" data-name="Ellipse 2" class="cls-1">
            <ellipse class="cls-2" cx="43.5" cy="43" rx="43.5" ry="43"/>
            <ellipse class="cls-3" cx="43.5" cy="43" rx="43" ry="42.5"/>
          </g>
          <g id="Group_1211" data-name="Group 1211" transform="translate(29.5 36)">
            <line id="Line_15" data-name="Line 15" class="cls-1" x1="33.427" transform="translate(0 7)"/>
            <line id="Line_16" data-name="Line 16" class="cls-1" x1="7" y2="7"/>
            <line id="Line_17" data-name="Line 17" class="cls-1" x1="7" y1="7" transform="translate(0 7)"/>
          </g>
        </svg>
        
        </button>
        <button type="button" className="btn" onClick={handleNext}>
        <svg id="Component_2_1" data-name="Component 2 – 1" xmlns="http://www.w3.org/2000/svg" width="auto" height="65" viewBox="0 0 87 86">
          <g id="Ellipse_1" data-name="Ellipse 1" class="cls-1">
            <ellipse class="cls-2" cx="43.5" cy="43" rx="43.5" ry="43"/>
            <ellipse class="cls-3" cx="43.5" cy="43" rx="43" ry="42.5"/>
          </g>
          <g id="Group_1212" data-name="Group 1212" transform="translate(26.786 36)">
            <line id="Line_15" data-name="Line 15" class="cls-1" x2="33.427" transform="translate(0 7)"/>
            <line id="Line_16" data-name="Line 16" class="cls-1" x2="7" y2="7" transform="translate(26.427)"/>
            <line id="Line_17" data-name="Line 17" class="cls-1" y1="7" x2="7" transform="translate(26.427 7)"/>
          </g>
        </svg>

        </button>
      </div>
      <label >{projects[currentIndex].name}</label>
    </div>
  );
}